export const NumField = ({ label, value, onChange, testId, hint, onReset, accent = "", placeholder = "0" }) => {
  const flip = () => {
    const v = String(value ?? "");
    onChange(v.startsWith("-") ? v.slice(1) : `-${v}`);
  };
  return (
    <div className="block min-w-0">
      <span className="flex items-center justify-between gap-1 text-[11px] font-semibold uppercase tracking-[0.12em] text-slate-500">
        <span className="truncate">{label}</span>
        {onReset && (
          <button type="button" data-testid={`${testId}-reset`} onClick={onReset}
            className="normal-case tracking-normal text-[11px] text-blue-700 underline underline-offset-2">use auto</button>
        )}
        {hint && !onReset && <span className="normal-case tracking-normal text-[10px] text-slate-400">{hint}</span>}
      </span>
      <div className={`mt-1.5 flex border border-slate-300 focus-within:border-slate-900 bg-white transition-colors ${accent}`}>
        <button type="button" onClick={flip} data-testid={`${testId}-sign`} tabIndex={-1}
          className="w-9 shrink-0 text-slate-500 font-mono text-sm border-r border-slate-200 hover:bg-slate-100">±</button>
        <input data-testid={testId} type="text" inputMode="decimal" value={value ?? ""} placeholder={placeholder}
          onChange={(e) => onChange(e.target.value.replace(/[^0-9.-]/g, ""))}
          className="w-full min-w-0 h-12 px-3 bg-transparent outline-none font-mono text-lg tabular-nums" />
      </div>
    </div>
  );
};
